import React, { useEffect, useState } from "react";
import {
  faNotesMedical,
  faUsers,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "@themesberg/react-bootstrap";

import { CounterWidget } from "../../components/Widgets";
import { fetchDashboardCounts } from "../../services/facilityService";

const Dashboard = () => {
  const [profileCounts, setProfileCounts] = useState({
    facility: 0,
    doctor: 0,
    patient: 0,
  });

  useEffect(() => {
    const fetchProfileCounts = async () => {
      try {
        const response = await fetchDashboardCounts();
        console.log("Data Received:", response);
        
        const newCounts = {
          facility: response.facilityCount ?? 0,
          doctor: response.doctorCount ?? 0,
          patient: response.patientCount ?? 0,
        };
        setProfileCounts(newCounts);
      } catch (error) {
        console.error("Failed to fetch dashboard counts:", error);
      }
    };

    fetchProfileCounts();
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4"></div>

      <Row className="justify-content-md-center">
        <Col xs={12} sm={6} xl={4} className="mb-4">
          <CounterWidget
            category="Facility/Alpha User"
            title={profileCounts.facility}
            period=""
            icon={faMapPin}
            iconColor="shape-secondary"
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4">
          <CounterWidget
            category="Doctor/Expert User"
            title={profileCounts.doctor}
            period=""
            icon={faNotesMedical}
            iconColor="shape-tertiary"
          />
        </Col>
        <Col xs={12} sm={6} xl={4} className="mb-4">
          <CounterWidget
            category="Patient/Avijo User"
            title={profileCounts.patient}
            period=""
            icon={faUsers}
            iconColor="shape-tertiary"
          />
        </Col>
      </Row>
    </>
  );
};

export default Dashboard;
